import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isOnboardingIaDemoSessionActive } from '../contexts/OnboardingDemoContext';
import { Loader2 } from 'lucide-react';

export function PrivateProRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, isPremium, isPremiumOnlyMode, onboardingCompleted, hasActiveTrialOnboarding } = useAuth();
  const location = useLocation();

  const isOnboardingIaDemo =
    location.pathname === '/ia-analysis' &&
    (
      isOnboardingIaDemoSessionActive(user?.uid)
      || new URLSearchParams(location.search).get('onboardingDemo') === 'true'
    );

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Si onboardingCompleted est null → encore en chargement depuis Firestore → attendre
  if (onboardingCompleted === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  // Si l'onboarding n'est pas terminé, forcer la redirection vers /onboarding
  if (onboardingCompleted === false) {
    return <Navigate to="/onboarding" replace />;
  }

  // Accès démo onboarding : analyse IA fictive pour utilisateurs trial sans premium
  if (isOnboardingIaDemo && hasActiveTrialOnboarding) {
    return <>{children}</>;
  }

  // Rediriger vers la page de tarification si l'utilisateur n'est pas premium
  if (!isPremium) {
    return <Navigate to="/pricing" />;
  }

  return <>{children}</>;
}
